export default {"src":"/login-app/[GIT_HASH]/_next/static/media/arrow_upward.34e4505e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};